export const validateCSS = (css: string): { isValid: boolean; error?: string } => {
    if (!css || css.trim() === '') {
        return { isValid: true };
    }

    try { 
        const trimmedCss = css.trim();
        const hasValidStructure = /[a-zA-Z0-9*.\-_#:][^{]*\{[^}]*\}/.test(trimmedCss);
        
        if (!hasValidStructure) {
        return {
            isValid: false,
            error: 'CSS must contain at least one valid rule with selector, braces, and properties'
        };
        }

        const openBraces = (css.match(/{/g) || []).length;
        const closeBraces = (css.match(/}/g) || []).length;
        
        if (openBraces !== closeBraces) {
        return { 
            isValid: false, 
            error: `Unbalanced braces: ${openBraces} opening and ${closeBraces} closing braces` 
        };
        }

        const lines = css.split('\n');
        let insideRuleset = false;
        
        for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        
        if (!line || line.startsWith('/*') || line.endsWith('*/')) {
            continue;
        }
        
        if (line.includes('{')) {
            insideRuleset = true;
            continue;
        }
        
        if (line.includes('}')) {
            insideRuleset = false;
            continue;
        }
        
        if (insideRuleset && line.includes(':')) {
            if (!line.endsWith(';') && !line.endsWith('{')) {
            return {
                isValid: false,
                error: `Missing semicolon on line ${i + 1}: "${line}"`
            };
            }
        }
        }

        return { isValid: true };
    } catch (error) {
        return { 
        isValid: false, 
        error: error instanceof Error ? error.message : 'Unknown error'
        };
    }
};